var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"infoBox",attrs:{"md":_vm.size}},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{class:_vm.classeP,style:({ 'font-size': (_vm.fontsize + "px") })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }